import React from 'react'
import * as R from 'ramda'

import { DropboxIntegrationSubPage } from 'pages/Admin/Integrations/Dropbox'
import useAxios from 'hooks/useAxios'

export default function DropboxIntegrationSubPageContainer() {
  const { data: user } = useAxios({
    url: 'account/users/me/v2/',
  })
  const { data: dropboxAuthentication, loading: isDropboxLoading } = useAxios({
    url: 'dropbox/authentication/',
  })
  return (
    <DropboxIntegrationSubPage
      isAuthenticated={R.prop('is_authenticated', dropboxAuthentication)}
      loading={!user || isDropboxLoading}
      userAccountId={R.prop('account_id', user)}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Integrations/Dropbox/container.js